import { useEffect } from "react";
import socket from "./socket";

const useSocketEvent = (
  event,
  handler,
  enabled = true
) => {
  useEffect(() => {
    if (!enabled || !event || !handler) return;

    socket.on(event, handler);

    return () => {
      socket.off(event, handler);
    };
  }, [event, handler, enabled]);
};

export default useSocketEvent;